import { useTranslation } from "react-i18next";

import LegalLayout from "./LegalLayout.jsx";
import LegalSections from "./LegalSections.jsx";
import { TERMS_CONTENT } from "./content/terms.js";

export default function Terms() {
  const { i18n, t } = useTranslation();
  const lang = i18n.language && TERMS_CONTENT[i18n.language]
    ? i18n.language
    : (i18n.language?.split("-")[0] || "uk");
  const content = TERMS_CONTENT[lang] || TERMS_CONTENT.uk;

  return (
    <LegalLayout
      title={content.title}
      lastUpdated={t("legal.lastUpdated", { date: content.lastUpdated })}
    >
      <p>{content.intro}</p>
      <LegalSections sections={content.sections} />
    </LegalLayout>
  );
}
